// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import styled, { css } from 'styled-components';

interface IProps {
  noPadding?: boolean;
}

export const Container = styled.div<IProps>`
  position: relative;
  width: 100%;
  height: 100%;

  ${(props) =>
    !props.noPadding &&
    css`
      padding: 20px;

      @media (max-width: 992px) {
        padding: 14px;
      }
    `}
`;
